import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import "./addNewBook.scss";
import Navbar from "../../components/navbar/Navbar";
import { CloudUpload } from "@mui/icons-material";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Chip,
  styled,
  Paper,
  Typography,
  Backdrop,
  CircularProgress,
  Grid,
  InputLabel,
  Select,
} from "@mui/material";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db, storage } from "../../firebase";
import { generateKeywords } from "../../functions";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { handleInputNumber } from "../../context/commonFunctions";
import { useUserChats } from "../../context/ChatsContext";

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function AddNewBook() {
  const { categories } = useUserChats();

  const [radioTypeValue, setRadioTypeValue] = useState("book");
  const [radioPaymentValue, setRadioPaymentValue] = useState("paid");
  const [categoryArray, setCategoryArray] = useState([]);
  const [subCategoryArray, setSubCategoryArray] = useState([]);
  const [categoryVlaue, setCategoryValue] = useState("");
  const [subCategoryValue, setSubCategoryValue] = useState("");
  const [tagServerData, setTagServerData] = useState([]);
  const [tagData, setTagData] = useState([]);
  const [image, setImage] = useState(null);
  const [samplePdf, setSamplePdf] = useState(null);
  const [mainPdf, setMainPdf] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    about: "",
    author: "",
    publisher: "",
    discount: 0,
    price: 0,
    isbn: "",
    language: "",
    pdf_password: "",
    pages: 0,
  });
  const [formErrors, setFormErrors] = useState({
    name: "",
    about: "",
    author: "",
    publisher: "",
    discount: "",
    price: "",
    isbn: "",
    language: "",
    pdf_password: "",
    pages: "",
  });
  const [open, setOpen] = useState(false);

  const [docRef, setDocRef] = useState(null);
  const [loadingDialogMessage, setLoadingDialogMessage] =
    useState("Please wait...");
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Pareeskha - Add Book";

    // Fetch data from Firestore
    const fetchData = async () => {
      try {
        const documentRef = doc(db, "Alphabet", "home");
        const snapshot = await getDoc(documentRef);
        const tags = snapshot.data().tags;
        setTagServerData(tags);
      } catch (error) {
        console.error("Error fetching data from Firestore:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    setCategoryArray(categories);
  }, [categories]);
  const validateForm = () => {
    const errors = {
      name: "",
      about: "",
      author: "",
      publisher: "",
      discount: "",
      price: "",
      isbn: "",
      language: "",
      pdf_password: "",
      pages: "",
    };

    let isValid = true;

    if (!formData.name.trim()) {
      errors.name = "Book Name cannot be empty";
      isValid = false;
    }
    if (!formData.about.trim()) {
      errors.about = "About cannot be empty";
      isValid = false;
    }
    if (!formData.author.trim()) {
      errors.author = "Author Name cannot be empty";
      isValid = false;
    }
    if (!formData.publisher.trim()) {
      errors.publisher = "Publisher Name cannot be empty";
      isValid = false;
    }
    if (formData.discount === "" || formData.discount === null || formData.discount === undefined) {
      errors.discount = "Discount cannot be empty";
      isValid = false;
    }
    if (!formData.price || formData.price === 0) {
      errors.price = "Price cannot be empty/zero";
      isValid = false;
    }
    if (!formData.isbn.trim()) {
      errors.isbn = "ISBN No. cannot be empty";
      isValid = false;
    }
    if (!formData.language.trim()) {
      errors.language = "Language cannot be empty";
      isValid = false;
    }
    if (!formData.pdf_password.trim()) {
      errors.pdf_password = "PDF Password cannot be empty";
      isValid = false;
    }
    if (!formData.pages || formData.pages === 0) {
      errors.pages = "PDF Pages cannot be empty/zero";
      isValid = false;
    }
    let alertMessage = "Validation Error:\n";

    if (!categoryVlaue.trim()) {
      isValid = false;
      alertMessage += "- Category selection is required.\n";
    }
    if (!subCategoryValue.trim()) {
      isValid = false;
      alertMessage += "- Sub Category selection is required.\n";
    }

    if (tagData.length === 0) {
      isValid = false;
      alertMessage +=
        "- Please add at least one tag for better categorization.\n";
    }

    if (image === null) {
      isValid = false;
      alertMessage += `- It's necessary to upload a cover image for your ${radioTypeValue} to enhance visibility.\n`;
    }

    if (samplePdf === null) {
      isValid = false;
      alertMessage +=
        "- Kindly select and upload a sample PDF file for preview purposes.\n";
    }

    if (mainPdf === null) {
      isValid = false;
      alertMessage +=
        "- Upload the main PDF file to provide the complete document.\n";
    }

    if (!isValid) {
      alert(alertMessage);
    }

    setFormErrors(errors);

    return isValid;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      var mapData = formData;

      const nameSearchArray = generateKeywords(formData.name);
      const authorSearchArray = generateKeywords(formData.author);
      const publisherSearchArray = generateKeywords(formData.publisher);
      const categorySearchArray = generateKeywords(categoryVlaue);
      const subCategorySearchArray = generateKeywords(subCategoryValue);

      var tagsSearchArray = [];
      tagData.forEach(
        (tag) =>
          (tagsSearchArray = [...tagsSearchArray, ...generateKeywords(tag)])
      );

      mapData = {
        ...mapData,
        category: categoryVlaue,
        subCategory: subCategoryValue,
        unitSold: 0,
        rating: 0.0,
        publish_on: serverTimestamp(),
        searchKeywords: [
          ...nameSearchArray,
          ...authorSearchArray,
          ...publisherSearchArray,
          ...categorySearchArray,
          ...subCategorySearchArray,
          ...tagsSearchArray,
        ],
        tags: tagData,
        payment_type:
          radioPaymentValue.charAt(0).toUpperCase() +
          radioPaymentValue.slice(1),
        eType: radioTypeValue.charAt(0).toUpperCase() + radioTypeValue.slice(1),
      };
      setOpen(true);
      setLoadingDialogMessage("Uploading book data...");

      try {
        const documentRef = await addDoc(
          collection(db, "pendingBooks"),
          mapData
        );
        setDocRef(documentRef);
        console.log("Document written with ID: ", documentRef.id);
      } catch (error) {
        setOpen(false);
        alert("Error uploading document: " + error);
      }
    } else {
      console.log("Form is not valid, do not submit");
    }
  };
  useEffect(() => {
    if (docRef) {
      uploadFilesToStorage(docRef);
    }
  }, [docRef]);

  const uploadFilesToStorage = async (documentRef) => {
    let pdfFileUrls = {};
    setLoadingDialogMessage("Performing assets upload...");

    const coverImgRef = ref(
      storage,
      "files/" + documentRef.id + "/cover_image.jpg"
    );
    const samplePDFRef = ref(
      storage,
      "files/" + documentRef.id + "/sample_" + documentRef.id + ".pdf"
    );
    const mainPDFRef = ref(
      storage,
      "files/" + documentRef.id + "/" + documentRef.id + ".pdf"
    );
    setLoadingDialogMessage("Cover Image uploading...");

    uploadBytes(coverImgRef, image)
      .then((snapshot) => {
        getDownloadURL(snapshot.ref).then((url) => {
          pdfFileUrls.coverImage = url;
          pdfFileUrls.thumbImage = url;
          setLoadingDialogMessage("PDF's uploading...");

          uploadBytes(samplePDFRef, samplePdf)
            .then((snapshot1) => {
              getDownloadURL(snapshot1.ref).then((url1) => {
                pdfFileUrls.samplePdfUrl = url1;
                uploadBytes(mainPDFRef, mainPdf)
                  .then((snapshot2) => {
                    getDownloadURL(snapshot2.ref).then(async (url2) => {
                      pdfFileUrls.pdfUrl = url2;

                      const bookRef = doc(db, "pendingBooks", documentRef.id);
                      try {
                        await updateDoc(bookRef, pdfFileUrls);
                        setOpen(false);
                        navigate("/pending-books");
                      } catch (error) {
                        alert(error);
                      }
                    });
                  })
                  .catch((error) => {
                    alert(error);
                  });
              });
            })
            .catch((error) => {
              alert(error);
            });
        });
      })
      .catch((error) => {
        alert(error);
      });
  };

  const addTag = (newTag) => {
    if (!tagData.includes(newTag)) {
      setTagData((prevTags) => [...prevTags, newTag]);
    }
  };

  const handleSamplePDFChange = (e) => {
    const selectedPdf = e.target.files[0];

    if (selectedPdf && selectedPdf.type === "application/pdf") {
      setSamplePdf(selectedPdf);
    } else {
      alert("Please select a valid PDF file.");
    }
  };
  const handleMainPDFChange = (e) => {
    const selectedPdf = e.target.files[0];

    if (selectedPdf && selectedPdf.type === "application/pdf") {
      setMainPdf(selectedPdf);
    } else {
      alert("Please select a valid PDF file.");
    }
  };

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    // Check if the selected file is an image
    if (selectedImage && selectedImage.type.startsWith("image/")) {
      setImage(selectedImage);
    } else {
      alert("Please select a valid image file.");
    }
  };

  const handleDeleteTag = (tagToRemove) => () => {
    setTagData((prevTags) => prevTags.filter((tag) => tag !== tagToRemove));
  };

  const handleRadioType = (event) => {
    setRadioTypeValue(event.target.value);
  };
  const handleRadioPaymentMode = (event) => {
    setRadioPaymentValue(event.target.value);
  };
  return (
    <div className="addNewbook">
      <Sidebar />

      <div className="addNewbookContainer">
        <Navbar />
        <div className="top">
          <h1>{"Add Book"}</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <img
              src={
                image
                  ? URL.createObjectURL(image)
                  : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
              }
              alt=""
            />
            <div className="formInput">
              <Button
                sx={{ marginTop: "10px" }}
                component="label"
                variant="outlined"
                startIcon={<CloudUpload />}
              >
                Select Image
                <VisuallyHiddenInput
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </Button>
            </div>
            <div className="formInput">
              <Typography sx={{ marginTop: "10px" }}>
                {samplePdf
                  ? "Selected Sample PDF  : " + samplePdf.name
                  : "Select a sample PDF file"}
              </Typography>
              <Button
                sx={{ marginTop: "10px" }}
                component="label"
                variant="outlined"
                startIcon={<CloudUpload />}
              >
                Choose file
                <VisuallyHiddenInput
                  type="file"
                  accept=".pdf*"
                  onChange={handleSamplePDFChange}
                />
              </Button>
            </div>
            <div className="formInput">
              <Typography sx={{ marginTop: "10px" }}>
                {mainPdf
                  ? "Selected PDF  : " + mainPdf.name
                  : "Select a PDF file"}
              </Typography>
              <Button
                sx={{ marginTop: "10px" }}
                component="label"
                variant="outlined"
                startIcon={<CloudUpload />}
              >
                Choose file
                <VisuallyHiddenInput
                  type="file"
                  accept=".pdf*"
                  onChange={handleMainPDFChange}
                />
              </Button>
            </div>
          </div>
          <div className="right">
            <div className="form">
              <div className="aboutInput" key={"name"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Book Name"
                  onChange={(e) => {
                    setFormData({ ...formData, name: e.target.value });
                  }}
                  error={formErrors.name !== ""}
                  helperText={formErrors.name}
                />
              </div>
              <div className="aboutInput" key={"about"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="About"
                  multiline
                  rows={4}
                  onChange={(e) => {
                    setFormData({ ...formData, about: e.target.value });
                  }}
                  error={formErrors.about !== ""}
                  helperText={formErrors.about}
                />
              </div>
              <div className="formInput" key={"auhtorName"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Author Name"
                  onChange={(e) => {
                    setFormData({ ...formData, author: e.target.value });
                  }}
                  error={formErrors.author !== ""}
                  helperText={formErrors.author}
                />
              </div>

              <div className="formInput" key={"publisherName"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Publisher Name"
                  onChange={(e) => {
                    setFormData({ ...formData, publisher: e.target.value });
                  }}
                  error={formErrors.publisher !== ""}
                  helperText={formErrors.publisher}
                />
              </div>
              <div className="formInput" key={"discount"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Discount"
                  onInput={handleInputNumber}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      discount: parseInt(e.target.value, 10) || 0,
                    });
                  }}
                  error={formErrors.discount !== ""}
                  helperText={formErrors.discount}
                />
              </div>
              <div className="formInput" key={"price"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Price"
                  onInput={handleInputNumber}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₹</InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      price: parseInt(e.target.value, 10) || 0,
                    });
                  }}
                  error={formErrors.price !== ""}
                  helperText={formErrors.price}
                />
              </div>
              <div className="formInput" key={"isbn"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="ISBN No."
                  onChange={(e) => {
                    setFormData({ ...formData, isbn: e.target.value });
                  }}
                  error={formErrors.isbn !== ""}
                  helperText={formErrors.isbn}
                />
              </div>
              <div className="formInput" key={"language"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Language"
                  onChange={(e) => {
                    setFormData({ ...formData, language: e.target.value });
                  }}
                  error={formErrors.language !== ""}
                  helperText={formErrors.language}
                />
              </div>

              <div className="formInput" key={"pdfPassword"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="PDF Password"
                  onChange={(e) => {
                    setFormData({ ...formData, pdf_password: e.target.value });
                  }}
                  error={formErrors.pdf_password !== ""}
                  helperText={formErrors.pdf_password}
                />
              </div>

              <div className="formInput" key={"category"}>
                <TextField
                  fullWidth
                  id="outlined-select-currency"
                  select
                  label="Category"
                  onChange={(e) => {
                    setCategoryValue(categories[e.target.value].title);
                    setSubCategoryArray(
                      categories[e.target.value].subCategories
                    );
                  }}
                >
                  {Object.keys(categoryArray).map((category) => (
                    <MenuItem
                      key={category}
                      value={category}
                    >
                      {categoryArray[category].title}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              {subCategoryArray.length != 0 && (
                <div className="formInput" key={"subcategory"}>
                  <TextField
                    fullWidth
                    id="outlined-select-currency"
                    select
                    label="Sub Category"
                    onChange={(e) => {
                      setSubCategoryValue(e.target.value);
                    }}
                  >
                    {subCategoryArray.map((subCategory) => (
                      <MenuItem key={subCategory} value={subCategory}>
                        {subCategory}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              )}
              <div className="formInput" key={"tags"}>
                <InputLabel id="demo-simple-select-label">Tags</InputLabel>
                <Select
                  fullWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={""}
                  label="Tags"
                  onChange={(e) => {
                    const newTag = e.target.value;
                    addTag(newTag.toLowerCase());
                  }}
                >
                  {tagServerData.map((value) => (
                    <MenuItem key={value} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className="formInput" key={"pages"}>
                <TextField
                  fullWidth
                  onInput={handleInputNumber}
                  id="pages"
                  label="PDF Pages"
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      pages: parseInt(e.target.value, 10) || 0,
                    });
                  }}
                  error={formErrors.pages !== ""}
                  helperText={formErrors.pages}
                />
              </div>
              <Paper
                elevation={0}
                sx={{
                  width: "92%",
                  display: "flex",

                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {tagData.map((data) => {
                  let icon;
                  return (
                    <ListItem key={data}>
                      <Chip
                        icon={icon}
                        label={data}
                        onDelete={handleDeleteTag(data)}
                      />
                    </ListItem>
                  );
                })}
              </Paper>
              <div className="formInput">
                <FormControl>
                  <FormLabel id="demo-controlled-radio-buttons-group-type">
                    Type
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group-type"
                    value={radioTypeValue}
                    onChange={handleRadioType}
                  >
                    <FormControlLabel
                      value="book"
                      control={<Radio size="small" />}
                      label="Book"
                    />
                    <FormControlLabel
                      value="notes"
                      control={<Radio size="small" />}
                      label="Notes"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="formInput">
                <FormControl>
                  <FormLabel id="demo-controlled-radio-buttons-group">
                    Payment Mode
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={radioPaymentValue}
                    onChange={handleRadioPaymentMode}
                  >
                    <FormControlLabel
                      value="paid"
                      control={<Radio size="small" />}
                      label="Paid"
                    />
                    <FormControlLabel
                      value="free"
                      control={<Radio size="small" />}
                      label="Free"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="formInput">
                <Button
                  onClick={handleSubmit}
                  sx={{ marginBottom: "20px" }}
                  fullWidth
                  variant="contained"
                >
                  Submit
                </Button>
              </div>

              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={open}
              >
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <CircularProgress
                    color="inherit"
                    value={10}
                    sx={{ marginBottom: "15px" }}
                  />
                  <Typography>{loadingDialogMessage}</Typography>
                </Grid>
              </Backdrop>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddNewBook;
